var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-aside-prices" }, [
    _vm.hasDiscount
      ? _c(
          "span",
          {
            staticClass: "product-aside-price product-aside-price--discounted",
          },
          [
            _c("span", { staticClass: "product-aside-price-was" }, [
              _vm._v(
                "Was " + _vm._s(_vm.price.compare_at_price_formatted_plus_vat)
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "product-aside-price-now" }, [
              _vm._v("Now " + _vm._s(_vm.price.price_formatted_plus_vat)),
            ]),
          ]
        )
      : _vm.product.market_prices && _vm.product.market_prices.length
      ? _c("span", { class: _vm.priceClass }, [
          _vm._v(
            "\n    " + _vm._s(_vm.price.price_formatted_plus_vat) + "\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("span", { staticClass: "product-aside-price-exvat" }, [
      _vm._v("tax & duties included"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }